import { auth } from '@rhitics/core'
import { AxiosError } from 'axios'
import Vue, { VNode } from 'vue'
import { validateCompanyEmail } from '@rhitics/rhitics/helpers'

type VForm = Vue & {
  reset: () => void
  validate: () => boolean
}

export default Vue.extend({
  name: 'ForgetPassword',

  data() {
    return {
      valid: false,
      dialog: false,
      sended: false,
      error: '',
      email: '',
      processing: false,
      rules: {
        required: (v: string) => !!v || 'Required',
        evolutivelabsEmail: (v: string) => validateCompanyEmail(v) || 'Incorrect email.'
      }
    }
  },

  watch: {
    email() {
      const $form = this.$refs.form as VForm
      this.valid = $form && $form.validate()
    }
  },

  methods: {
    async send(event: Event) {
      if (this.processing) return false
      const $form = this.$refs.form as VForm
      try {
        this.processing = true
        await auth.sendResetPasswordEmail(this.email)
        this.sended = true
        $form.reset()
      } catch (e) {
        if ((e as AxiosError).response?.status === 404) {
          this.error = 'Email doest not exist.'
        } else if ((e as AxiosError).response?.status === 401) {
          this.error = (e as AxiosError).response?.data.message
        } else {
          window.console.error((e as AxiosError).response)
          this.error = 'Oops! Something went wrong, please contact IT team.'
        }
        window.setTimeout(() => (this.error = ''), 5000)
      } finally {
        this.processing = false
      }
      event.preventDefault()
    }
  },

  render(): VNode {
    const emailFrom = (
      <v-form ref="form" on={{ submit: this.send }}>
        <v-text-field class="py-4" rules={Object.values(this.rules)} v-model={this.email} label="Email" type="email" />
        <v-row>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            type="submit"
            on={{ click: this.send }}
            disabled={this.processing || !!this.error || !this.valid}
            loading={this.processing}
          >
            Submit
          </v-btn>
        </v-row>
      </v-form>
    )

    const sucessAlert = (
      <v-alert outlined type="success">
        Rhitics will send reset password email to you, Please check <a href="https://gmail.com">Gmail</a>.
      </v-alert>
    )

    const errorAlert = (
      <v-alert dense outlined type="error">
        {this.error}
      </v-alert>
    )

    return (
      <v-dialog
        width="500"
        v-model={this.dialog}
        scopedSlots={{
          activator: (props: any) => (
            <v-btn text small on={props.on}>
              Forget Password ?
            </v-btn>
          )
        }}
      >
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Reset Password
          </v-card-title>
          <v-card-text>
            {emailFrom}
            {this.sended ? sucessAlert : null}
            {this.error ? errorAlert : null}
          </v-card-text>
        </v-card>
      </v-dialog>
    )
  }
})
